import api from '../../lib/api';
import type {
  EmergencyDrillPayload,
  EmergencyPlanPayload,
  PaginatedEmergencyDrills,
  PaginatedEmergencyPlans,
  UpcomingDrillPlan,
} from './types';

export interface ListEmergencyPlansParams {
  page?: number;
  pageSize?: number;
  scenario?: string;
  status?: string;
  search?: string;
}

export interface ListEmergencyDrillsParams {
  page?: number;
  pageSize?: number;
  planId?: string;
  result?: string;
  search?: string;
}

export const fetchEmergencyPlans = async (
  params: ListEmergencyPlansParams = {},
): Promise<PaginatedEmergencyPlans> => {
  const { data } = await api.get<PaginatedEmergencyPlans>('emergency-plans', { params });
  return data;
};

export const fetchUpcomingDrills = async (): Promise<UpcomingDrillPlan[]> => {
  const { data } = await api.get<{ data: UpcomingDrillPlan[] }>('emergency-plans/upcoming');
  return data.data;
};

export const createEmergencyPlan = async (payload: EmergencyPlanPayload) => {
  const { data } = await api.post('emergency-plans', payload);
  return data;
};

export const updateEmergencyPlan = async (id: string, payload: Partial<EmergencyPlanPayload>) => {
  const { data } = await api.put(`emergency-plans/${id}`, payload);
  return data;
};

export const fetchEmergencyDrills = async (
  params: ListEmergencyDrillsParams = {},
): Promise<PaginatedEmergencyDrills> => {
  const { data } = await api.get<PaginatedEmergencyDrills>('emergency-drills', { params });
  return data;
};

export const createEmergencyDrill = async (payload: EmergencyDrillPayload) => {
  const { data } = await api.post('emergency-drills', payload);
  return data;
};

export const updateEmergencyDrill = async (id: string, payload: Partial<EmergencyDrillPayload>) => {
  const { data } = await api.put(`emergency-drills/${id}`, payload);
  return data;
};

export const escalateDrillFindings = async (id: string, title?: string, description?: string) => {
  const { data } = await api.post(`emergency-drills/${id}/escalate`, { title, description });
  return data;
};
